import "ol/ol.css";
import { Map, View } from "ol";
import OSM from 'ol/source/OSM';
import TileLayer from "ol/layer/Tile";
import * as olProj from 'ol/proj';
import { defaults as defaultControls } from 'ol/control';
import VectorLayer from 'ol/layer/Vector';
import XYZ from 'ol/source/XYZ';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import VectorSource from 'ol/source/Vector';
import Overlay from 'ol/Overlay';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileImage from 'ol/source/TileImage';
import { Icon, Style, Stroke } from 'ol/style';
import { wgs84ToGcj02, gcj02ToWgs84 } from './ConverseLngAndLa'
const mapUrl = {
    baiduMap: {
        normal: "http://online0.map.bdimg.com/onlinelabel/?qt=tile&x={0}&y={1}&z={2}&styles=pl&udt=20151021&scaler=1&p=1&customid=grassgreen",
        // normal: "http://api0.map.bdimg.com/customimage/tile?&x={0}&y={1}&z={2}&udt=20181010&scale=1&ak=w5MD7jG50zNdbxKwIwG9pFUg2Pf9AouO&customid=grassgreen",
        // normal: "http://127.0.0.1/normal/{3}/{1}/{2}.jpg",
        //卫星地图url
        sat: 'http://shangetu' + parseInt(Math.random() * 10) + '.map.bdimg.com/it/u=x={0};y={1};z={2};v=009;type=sate&fm=46&udt=20170606',
        //卫星标注
        // hybrid: 'http://online{0}.map.bdimg.com/tile/?qt=vtile&x={1}&y={2}&z={3}&styles=sl&udt=20180926'
        hybrid: 'http://online{0}.map.bdimg.com/tile/?qt=vtile&x={1}&y={2}&z={3}&styles=sl&udt='
            //离线地图,填写的nginx代理地址，指向离线瓦片图资源
            // hybrid: "http://127.0.0.1/hybrid/{3}/{1}/{2}.jpg"
    },
    googleMap: {
        normal: "http://mt2.google.cn/vt/lyrs=m@167000000&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}",
        //卫星
        sat: "http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
        //卫星带标注
        hybrid: "http://mt2.google.cn/vt/lyrs=y&hl=zh-CN&gl=CN&src=app&x={x}&y={y}&z={z}&s=G"
            //离线地图,填写本地的nginx代理地址，指向离线瓦片图资源
            // hybrid:"http://10.10.10.3/googleNewMocartooSheets/{z}/{x}/{y}.jpg"
    }
}

let baiduMapLayer = {};
let googleMapLayer = {};

let vectorZindex = 101;

let raster = new TileLayer({
    source: new OSM({
        wrapX: false
    })
});
let _source;
let _vector = new VectorLayer({
    source: _source,
    zIndex: vectorZindex++
});

const point1 = olProj.transform([-180, -85], "EPSG:4326", "EPSG:3857");
const point2 = olProj.transform([180, 85], "EPSG:4326", "EPSG:3857");

/**
 * 字符窜格式化
 */
String.prototype.format = function() {
    if (arguments.length == 0) {
        return this;
    }
    for (var s = this, i = 0; i < arguments.length; i++) {
        s = s.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
    }
    return s;
}

function createMap() {
    let map = new Map({
        layers: [raster, _vector],
        view: new View({ // 地图视图
            maxZoom: 12,
            minZoom: 0,
            projection: 'EPSG:3857',
            zoom: 5,
            extent: [point1[0], point1[1], point2[0], point2[1]],
            multiWorld: false
        }),
        controls: defaultControls({
            attribution: false,
            rotate: false
        })
    });
    return map;
}

/**
 * 创建百度地图(默认为卫星模式)
 */
function createBaiduMap(tag, center, mType) {
    let map = createMap();
    map.setTarget(tag);
    map.getView().setCenter(olProj.transform(center, 'EPSG:4326', 'EPSG:3857'));
    if ("normal" === mType) {
        baiduMapLayer.normal = createBaiduMapLayer(mapUrl.baiduMap.normal);
        map.addLayer(baiduMapLayer.normal);
    } else if ("hybrid" === mType) {
        baiduMapLayer.sat = createBaiduMapLayer(mapUrl.baiduMap.sat);
        baiduMapLayer.hybrid = createBaiduMapLayer(mapUrl.baiduMap.hybrid);
        map.addLayer(baiduMapLayer.sat);
        map.addLayer(baiduMapLayer.hybrid);
    }
    return map;
}

/**
 * 修改百度地图模式
 * @param {*} mapType 
 * @param {*} map 
 */
function changeBaiduMapStyle(mapType, map) {
    removeTileLayers(map);
    if ("normal" === mapType) {
        if (!baiduMapLayer.normal) {
            baiduMapLayer.normal = createBaiduMapLayer(mapUrl.baiduMap.normal);
        }
        map.addLayer(baiduMapLayer.normal);
    } else { //if ("hybrid" === mapType)
        if (!baiduMapLayer.sat) {
            baiduMapLayer.sat = createBaiduMapLayer(mapUrl.baiduMap.sat);
        }
        if (!baiduMapLayer.hybrid) {
            baiduMapLayer.hybrid = createBaiduMapLayer(mapUrl.baiduMap.hybrid);
        }
        map.addLayer(baiduMapLayer.sat);
        map.addLayer(baiduMapLayer.hybrid);
    }
}

/**
 * 创建百度地图瓦片图层
 * @param {Object} _url
 */
function createBaiduMapLayer(_url) {
    //百度地图
    // 自定义分辨率和瓦片坐标系
    var resolutions = [];
    var maxZoom = 18;

    // 计算百度使用的分辨率
    for (var i = 0; i <= maxZoom; i++) {
        resolutions[i] = Math.pow(2, maxZoom - i);
    }
    var tilegrid = new TileGrid({
        origin: [0, 0], // 设置原点坐标
        resolutions: resolutions, // 设置分辨率
    });

    // 百度地图层
    var bLayer = new TileLayer({
        source: new TileImage({
            projection: 'EPSG:3857',
            tileGrid: tilegrid,
            tileUrlFunction: function(tileCoord, pixelRatio, proj) {
                var z = tileCoord[0];
                var x = tileCoord[1];
                var y = -tileCoord[2] - 1;
                // 百度瓦片服务url将负数使用M前缀来标识
                if (_url.indexOf("customid=grassgreen") == -1) {
                    if (x < 0) {
                        x = 'M' + (-x);
                    }
                    if (y < 0) {
                        y = 'M' + (-y);
                    }
                }
                if (_url.indexOf("{3}") != -1) {
                    return _url.format(parseInt(Math.random() * 10), x, y, z);
                } else {
                    return _url.format(x, y, z);
                }
            },
            wrapX: false
        })
    });
    return bLayer;
}


/**
 * 初始化地图
 **/
export function initMap(target, center, mapType, oldMap) {
    if (oldMap) {
        removeTileLayers(oldMap);
    }
    // let map = createMap();
    // map.setTarget(target);
    // map.getView().setCenter(olProj.transform(center, 'EPSG:4326', 'EPSG:3857'));
    // if ("normal" === mapType) {
    //     googleMapLayer.normal = createMapLayer(mapUrl.googleMap.normal);
    //     map.addLayer(googleMapLayer.normal);
    // } else if ("hybrid" === mapType) {
    //     googleMapLayer.hybrid = createMapLayer(mapUrl.googleMap.hybrid);
    //     map.addLayer(googleMapLayer.hybrid);
    // }

    return createBaiduMap(target, center, mapType);
}
/**
 * 切换地图模式
 **/
export function changeMapStyle(mapType, map) {
    removeTileLayers(map);
    // if ("normal" === mapType) {
    //     if (!googleMapLayer.normal) {
    //         googleMapLayer.normal = createMapLayer(mapUrl.googleMap.normal);
    //     }
    //     map.addLayer(googleMapLayer.normal);
    // } else if ("hybrid" === mapType) {
    //     if (!googleMapLayer.hybrid) {
    //         googleMapLayer.hybrid = createMapLayer(mapUrl.googleMap.hybrid);
    //     }
    //     map.addLayer(googleMapLayer.hybrid);
    // } else {
    //     if (!googleMapLayer.hybrid) {
    //         googleMapLayer.hybrid = createMapLayer(mapUrl.googleMap.hybrid);
    //     }
    //     map.addLayer(googleMapLayer.hybrid);
    // }

    changeBaiduMapStyle(mapType, map); //修改百度地图模式
}
/**
 * 创建百度地图图层之外的地图图层
 * 
 * @param {Object} _url
 */
function createMapLayer(_url) {
    let layer = new TileLayer({
        source: new XYZ({
            url: _url,
            wrapX: false
        })
    });
    return layer;
}
/**
 * 删除地图瓦片图层
 */
function removeTileLayers(map) {
    let layers = [];
    map.getLayers().forEach(function(layer) {
        if (layer instanceof TileLayer) {
            layers.push(layer);
        }
    });
    for (let i in layers) {
        map.removeLayer(layers[i]);
    }
}
/**
 * 绘制点
 * 
 * @param {Object} map
 * @param {Array} infoArr
 * @param {Object} airspaceStyle
 **/
export function addPoint(map, infoArr, airspaceStyle) {
    for (let i in infoArr) {
        let info = infoArr[i];
        let lng = info.longtitude;
        if (isNaN(lng)) {
            continue;
        }
        let lat = info.latitude;
        if (isNaN(lat)) {
            continue;
        }
        let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理     
        coordinate = olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
        info.coordinate = coordinate;
        let id = info ? info.id : "";
        let feature = new Feature({
            id: id,
            geometry: new Point(coordinate),
            data: info,
        });
        feature.setStyle(
            new Style({
                image: new Icon({
                    src: airspaceStyle.src,
                    crossOrigin: '',
                }),
            })
        );
        let source = new VectorSource({
            wrapX: false,
        });
        source.addFeature(feature);
        let vector = new VectorLayer({
            source: source,
            zIndex: vectorZindex++
        });
        map.addLayer(vector);
    }
}
/**
 * 绘制首尾点
 * 
 * @param {Object} map
 * @param {Array} infoArr
 * @param {Object} airspaceStartStyle
 * @param {Object} airspaceEndStyle
 **/
export function addHeadAndTailPoint(map, infoArr, airspaceStartStyle, airspaceEndStyle) {
    for (let i in infoArr) {
        if (Number(i) === 0 || Number(i) === infoArr.length-1) {
            let info = infoArr[i];
            let lng = info.longtitude;
            if (isNaN(lng)) {
                continue;
            }
            let lat = info.latitude;
            if (isNaN(lat)) {
                continue;
            }
            let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理
            coordinate = olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
            info.coordinate = coordinate;
            let id = info ? info.id : "";
            let feature = new Feature({
                id: id,
                geometry: new Point(coordinate),
                data: info,
            });
            if (Number(i) === 0) {
                feature.setStyle(
                    new Style({
                        image: new Icon({
                            src: airspaceStartStyle.src,
                            crossOrigin: '',
                        }),
                    })
                );
            } else {
                feature.setStyle(
                    new Style({
                        image: new Icon({
                            src: airspaceEndStyle.src,
                            crossOrigin: '',
                        }),
                    })
                );
            }
            let source = new VectorSource({
                wrapX: false,
            });
            source.addFeature(feature);
            let vector = new VectorLayer({
                source: source,
                zIndex: vectorZindex++
            });
            map.addLayer(vector);
        }
    }
}
/**
 * 绘制线(点集数组结构是[[[xxxx,xxxx],[   xxxx,xxxx],.....]])
 * @param {Object} map
 * @param {Object} info
 * @param {Array} points
 * @param {Object} airspaceStyle
 * */
export function addLine(map, info, points, airspaceStyle) {
    let line = new LineString(points); //绘制线(点集数组结构是[[[xxxx,xxxx],[   xxxx,xxxx],.....]])
    let id = info ? info.id : "";
    let feature = new Feature({
        id: id,
        geometry: line,
        data: info,
    });
    feature.setId(id);
    var source = new VectorSource({
        wrapX: false,
    });
    source.addFeature(feature);
    var vector = new VectorLayer({
        source: source,
        style: new Style({
            stroke: new Stroke({
                color: airspaceStyle.strokeColorRgba,
                width: airspaceStyle.strokeWeight,
                lineDash: airspaceStyle.lineDash,
            }),
        }),
        zIndex: vectorZindex++
    });
    map.addLayer(vector);
    return vector;
}
/**
 * 绘制覆盖物
 * 
 * @param {Object} map
 * @param {Array} infoArr
 **/
export function addOverlay(map, infoArr) {
    for (let i in infoArr) {
        let info = infoArr[i];
        if (info && info.id) {
            let lng = info.longtitude;
            if (isNaN(lng)) {
                continue;
            }
            let lat = info.latitude;
            if (isNaN(lat)) {
                continue;
            }
            let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理     
            coordinate = olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标

            let flight_status = info.flight_status;
            let element = document.createElement("div");
            let title = document.createElement("div");
            title.className = "title";
            let titleContent = document.createElement("div");
            titleContent.className = "titleContent";
            titleContent.innerText = info.modelName;
            title.appendChild(titleContent);
            element.appendChild(title);
            let content = document.createElement("div");
            content.className = "content";
            let uavNo = document.createElement("div");
            uavNo.innerText = "编号：" + info.uavNo;
            content.appendChild(uavNo);
            let longtitude = document.createElement("div");
            longtitude.innerText = "经度：" + Number(info.longtitude).toFixed(6) + " °";
            content.appendChild(longtitude);
            let latitude = document.createElement("div");
            latitude.innerText = "纬度：" + Number(info.latitude).toFixed(6) + " °";
            content.appendChild(latitude);
            let altitude = document.createElement("div");
            altitude.innerText = "高度：" + Number(info.altitude).toFixed(3) + " m";
            content.appendChild(altitude);

            element.appendChild(content);
            if (70 === flight_status) {
                element.className = "flyOver";
            } else if (60 === flight_status) {
                element.className = "flying";
            } else if (50 === flight_status) {
                element.className = "waiting";
            }
            let overlay = new Overlay({
                id: info.id,
                element: element, //绑定 Overlay 对象和 DOM 对象的
                offset: [18, 0],
                position: coordinate,
                positioning: 'top-left',
                insertFirst: false,
                autoPan: true, // 定义弹出窗口在边缘点击时候可能不完整 设置自动平移效果
                autoPanAnimation: {
                    duration: 250, //当Popup超出地图边界时，地图移动的速度
                },
            });
            map.addOverlay(overlay);
        }
    }
}

/**
 * 移除点
 * 
 * @param {Object} map
 * @param {Array} featureIds
 *
 * */
export function removePoint(map, featureIds) {
    if (featureIds && featureIds.length > 0) {
        map.getLayers().forEach(function(layer) {
            if (layer instanceof VectorLayer) {
                let source = layer.getSource();
                if (source) {
                    source.forEachFeature(function(feature) {
                        let featuerInfo = feature.getProperties();
                        if (featuerInfo) {
                            let id = featuerInfo.id;
                            if (id) {
                                let index = featureIds.findIndex((item) => {
                                    return item == id;
                                });
                                if (index !== -1) {
                                    source.removeFeature(feature);
                                }
                            }
                        }
                    });
                }
            }
        });
    }
}

/**
 * 移除覆盖物
 * 
 * @param {Object} map
 * @param {Array} overlayIds
 *
 * */
export function removeOverlay(map, overlayIds) {
    if (overlayIds && overlayIds.length > 0) {
        overlayIds.forEach((overlayId) => {
            let overlay = map.getOverlayById(overlayId);
            if (overlay) {
                map.removeOverlay(overlay);
            }
        });
    }
}
/**
 * 添加单击事件
 * 
 * */
export function addEventListener(map, callback) {
    if (map) {
        map.on('singleclick', function(evt) {
            let feature = map.forEachFeatureAtPixel(evt.pixel,
                function(feature) {
                    return feature;
                }
            );
            if (feature) {
                if (feature.getProperties().features) { //聚合情况下
                    if (1 === feature.getProperties().features.length) { //只有一个要素
                        let featuerInfo = feature.getProperties().features[0];
                        let id = featuerInfo.get("id"); //我们可以通过给点标记传不同的值，来判断点击不同的点标记触发的事件。
                        if (id) { //含有 id 参数的点标记触发事件
                            let info = featuerInfo.get("data");
                            callback(info);
                        }
                    }
                } else {
                    let id = feature.get("id"); //我们可以通过给点标记传不同的值，来判断点击不同的点标记触发的事件。
                    if (id) { //含有 id 参数的点标记触发事件
                        let info = feature.get("data");
                        callback(info);
                    }
                }
            }
        });
    }
}
/**
 * 移除单击事件
 * */
export function removeEventListener(map) {
    if (map) {
        map.removeEventListener('singleclick');
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/map/OlMapUtil.js